{
  "button-bar-for-continue-booking": {
    "button": {
      "cancel": "Hủy",
      "continue": "Tiếp tục"
    },
    "text": {
      "continue-booking": "Đặt hẹn của bạn vẫn chưa hoàn tất. Bạn có muốn tiếp tục không?"
    }
  }
}
